<template>
  <div class="ren-decoration-cp ren-decoration-cp-button" :class="{ 'is-full': fullWidth }">
    <button type="button" :disabled="disabled" :style="buttonStyle">{{ text }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const text = computed(() =>
  stringValue(props.component.props?.text ?? props.component.props?.label, '按钮')
)
const disabled = computed(() => booleanValue(props.component.props?.disabled, false))
const fullWidth = computed(() => booleanValue(props.component.props?.fullWidth, false))
const buttonStyle = computed(() => {
  const style = props.component.style ?? {}
  const radius = Number(style.radius)
  return {
    backgroundColor:
      stringValue(style.backgroundColor) ||
      props.themeTokens?.primaryColor ||
      props.themeColor ||
      'var(--ren-theme-primary)',
    color: stringValue(style.textColor) || props.themeTokens?.buttonTextColor || '#fff',
    borderRadius: Number.isFinite(radius) && radius >= 0 ? `${radius}px` : undefined,
    width: fullWidth.value ? '100%' : undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-button {
  display: flex;
  justify-content: center;
}

.ren-decoration-cp-button.is-full {
  display: block;
}

.ren-decoration-cp-button button {
  min-height: 40px;
  border: 0;
  padding: 0 16px;
  font: inherit;
  cursor: default;
}

.ren-decoration-cp-button button:disabled {
  opacity: 0.6;
}
</style>
